export type NotificationStatus = "Success" | "Error" | "Queued" | string;

const notificationStatusLookup: {
  [key: NotificationStatus]: "success" | "error" | "queued";
} = {
  Success: "success",
  Error: "error",
  Queued: "queued",
};

export const notificationStatusToName = (id: string) => {
  return notificationStatusLookup[id];
};
